import { cn } from "@getgreenline/blaze-ui";

type FormTipProps = {
  children: React.ReactNode;
  className?: string;
};

export function FormTip({ children, className }: FormTipProps) {
  return (
    <p className={cn("tw:mt-3 tw:text-sm tw:text-muted-foreground", className)}>
      {children}
    </p>
  );
}
